import { render, staticRenderFns } from "./agentCourseDialog.vue?vue&type=template&id=07b8f566&scoped=true&"
import script from "./agentCourseDialog.vue?vue&type=script&lang=js&"
export * from "./agentCourseDialog.vue?vue&type=script&lang=js&"
import style0 from "./agentCourseDialog.vue?vue&type=style&index=0&id=07b8f566&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b8f566",
  null
  
)

export default component.exports